import React, { useState, useEffect } from 'react'

import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { cloneDeep } from 'lodash-es'
import HTMLWidget from '../../HTMLWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { doneLoading, startLoading } from '../../../utils/loading'
import { setAlertMessage } from '../../../utils/messageUtil'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import EditFormTableWidget from '../dynamicForm/EditFormTableWidget'
import {
  delFormProjectCoMakerById,
  saveFormProjectCoMaker,
} from '../../../redux/actions/subProjectProposal'
import ViewFormTableWidget from '../dynamicForm/ViewFormTableWidget'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import EditButton from '../../../components/buttons/editButton/EditButton'

export default function PCoMakerWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isEditRow, setIsEditRow] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [objectDatas, setObjectDatas] = useState(props.schema?.objects)
  const [editId, setEditId] = useState()

  const [coMakerCount, setCoMakerCount] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    setCount(props.schema)
  }, [props.schema])

  const setCount = (schema) => {
    var coMakerCount = schema?.datas?.filter(
      (e) => e.values?.find((se) => se.key == 'role' && se.value == '1') != null
    )?.length

    var total = schema?.datas?.length

    setCoMakerCount(total - coMakerCount)
  }

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormProjectCoMaker(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setCount(response)
        setIsEditRow(false)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDel = async (data) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await delFormProjectCoMakerById(subProjectId, data.id)
      if (response) {
        setFormSchema(response)
        setCount(response)
        //setObjectDatas(response.objects)
        setAlertMessage('success', DELETE_SUCCESS_MSG)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG)
      }
    } catch (e) {
      //console.log('error', e)

      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []
    let subForm = []

    formSchema.objects?.forEach((e) => {
      if (e.type == 'RUNNING' || e.type == 'HEADER_LABEL' || e.type == 'LABEL') {
        //ไม่ทำอะไร
      } else if (e.type == 'ADDRESS') {
        e.subSchemas?.forEach((se) => {
          if (se.sameAddress && data[se.sameAddress.name] != '0') {
            var sameValue = data[se.sameAddress.name]

            subForm.forEach((sev) => {
              if (
                sev.typeId == e.id &&
                (sev.values[0].key == sameValue ||
                  sev.values.find((e) => e.name == 'otherRefers' && e.value == sameValue))
              ) {
                sev.values.push({
                  //key: se.typeId,
                  name: 'otherRefers',
                  value: se.typeId,
                  //type: seo.type,
                })
              }
            })
          } else {
            let subValues = []

            se.objects?.forEach((seo) => {
              subValues.push({
                key: se.typeId,
                name: seo.name,
                value: data[seo.name] || null,
                type: seo.type,
              })
            })

            subForm.push({
              id: se.id,
              typeId: e.id,
              values: subValues,
            })
          }
        })
      } else {
        values.push({
          key: e.id,
          name: e.name,
          value: data[e.name] || null,
          type: e.type,
        })
      }
    })

    let request = {
      id: isEditRow ? editId : '',
      values: values,
      subForm: subForm,
    }

    //console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  const onEdit = (data) => {
    // console.log('data', data)
    var obj = cloneDeep(objectDatas)

    obj.forEach((e) => {
      if (e.type == 'ADDRESS') {
        e.subSchemas?.forEach((se) => {
          let addressData = data?.values?.find((v) => v.key == 'address')

          se.id = addressData?.id

          se.objects?.forEach((seo) => {
            let key = seo.name.split(':')?.pop()

            seo.value = addressData?.subDatas?.find((v) => v.key == key)?.value
          })
        })
      } else {
        e.value = data?.values?.find((v) => v.key == e.name)?.value
      }
    })

    // console.log('obj : ', obj)

    setObjectDatas(obj)

    setEditId(data.id)
    setIsEditRow(true)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }

  const onCancel = () => {
    setIsEditRow(false)
    setEditId('')
    setObjectDatas(formSchema.objects)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      <HTMLWidget
        style={{ marginTop: 10, marginBottom: 10, marginLeft: 10 }}
        data={formSchema.detail}
      />

      <div
      // ref={(section) => {
      //   setSection(section)
      // }}
      >
        {isEdit && showCommandButton && (
          <>
            {coMakerCount < formSchema.minimum && (
              <div style={{ marginBottom: 15 }}>
                <Message
                  showIcon
                  type="error"
                  description={`ขาด ${formSchema.header} ${
                    formSchema.minimum - coMakerCount
                  } คนจากเงื่อนไข อย่างน้อย ${formSchema.minimum} คน ไม่รวมผู้รับผิดชอบโครงการ`}
                />
              </div>
            )}
            <EditFormTableWidget
              schema={formSchema}
              objectDatas={objectDatas}
              preView={mode}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              isEdit={isEditRow}
              handleSubmit={handleSubmit}
              notiMsg={notiMsg}
              setNotiMsg={setNotiMsg}
              onSave={onSubmit}
              onCancel={onCancel}
              conditions={[{ name: 'otherRole', ref: 'role', value: '6' }]}
            />
          </>
        )}
      </div>

      <ViewFormTableWidget
        schema={formSchema}
        enableEdit={isEdit && showCommandButton}
        onDelete={handleDel}
        onEdit={onEdit}
      />

      {showCommandButton && !mode && (
        <div className="right">
          <hr />

          {isEdit ? (
            <div>
              <ViewButton
                icon="backward"
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                }}
                disabled={isLoading}
              >
                {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </ViewButton>
            </div>
          ) : (
            <EditButton
              onClick={() => {
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
              disabled={isLoading}
            >
              {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
            </EditButton>
          )}
        </div>
      )}
    </Panel>
  )
}
